const getQuestions = categoryArr => {
  const que = _.cloneDeep(questions)
  const result = {
    common: que.common,
  }
  if (Array.isArray(categoryArr) && categoryArr.length > 0) {
    categoryArr.forEach(category => {
      if (que[category]) {
        result[category] = que[category]
      }
    })
  }
  return result || {}
}

const questions = {
  common: [
    {
      id: '1',
      type: 'radio',
      answer: '',
      stem: '您好【话术】，您现在方便吗？占用您一分钟。【职位详情】您现阶段有可能考虑接触吗？',
      options: {
        A: '考虑', // Y
        B: '不考虑',
      },
      link: '长期意向',
      recover: true,
    },
    {
      id: '2',
      type: 'radio',
      answer: '',
      stem: '你是什么机会都不考虑，还是不考虑这个机会？',
      options: {
        C: '什么都不考虑', // N
        D: '不考虑这个',
      },
      link: '长期意向',
      recover: true,
      hidden: true,
    },
    {
      id: '3',
      type: 'input',
      stem: '你有朋友介绍吗？',
      text: '',
      textLink: '沟通备注',
      hidden: true,
    },
    {
      id: '7',
      type: 'sort',
      answer: [],
      stem: '抛开这个机会不说，您最理想的机会是什么样的？或者以下的因素您怎么排序呢？或者您内心有没有目标机构呢？ ',
      options: [
        '平台（大平台）',
        '固薪（高固薪）',
        '激励（高激励）',
        '职位（高职级）',
        '工作生活平衡（压力小）',
        '做成事情',
        '发展空间',
        '领导风格',
      ],
      link: '沟通备注',
      text: '',
      textLink: '沟通备注',
      hidden: true,
    },
    {
      id: '4',
      type: 'radio',
      answer: '',
      stem: '您对他们公司熟悉吗？之前有接触过吗？',
      options: {
        A: '不熟悉，没接触过',
        B: '熟悉，但没申请过该公司职位',
        C: '熟悉，且已经申请过了',
      },
      link: '沟通备注',
    },
    {
      id: '5',
      type: 'radio',
      answer: '',
      stem: '您目前的职位是？会带多大的团队呢？',
      options: {
        A: '公司高管（分管这块业务）',
        B: '部门总',
        C: '部门副总/团队长',
        D: '部门核心骨干（有4年及以上经验；项目负责人）',
        E: '新人（工作不足3年）',
        F: '研究',
        G: '其他',
      },
      link: '职级',
      recover: true,
    },
    {
      id: '6',
      type: 'radio',
      answer: '',
      stem: '您在部门内部（您带的团队）今年的考核排名怎么样？排在很靠前的位置吗？',
      options: {
        A: '排在非常靠前(前1/4)（公司平台，个人业绩、资源都非常好）',
        B: '排在非常靠前(前1/4)（特别有信心的回答）',
        C: '嗯，排在比较前面',
        D: '还可以，但因为市场情况（大段解释）',
        E: '我们没有考核标准',
        F: '回避问题或风评不好',
      },
      link: '业绩',
      text: '',
      recover: true,
    },
    {
      id: '7',
      type: 'sort',
      answer: [],
      stem: '抛开这个机会不说，您最理想的机会是什么样的？或者以下的因素您怎么排序呢？或者您内心有没有目标机构呢？ ',
      options: [
        '平台（大平台）',
        '固薪（高固薪）',
        '激励（高激励）',
        '职位（高职级）',
        '工作生活平衡（压力小）',
        '做成事情',
        '发展空间',
        '领导风格',
        '想去甲方',
      ],
      link: '沟通备注',
      text: '',
      textLink: '沟通备注',
      textLabel: '意向机构',
    },
    {
      id: '8',
      type: 'radio',
      answer: '',
      stem: '您更偏好什么类型的公司？创业型、市场化？还是国资？',
      options: {
        A: '极度市场化（类似：天风证券）',
        B: '较市场化（类：华兴资本）',
        C: '大平台、合理激励（类：嘉实资本）',
        D: '偏向国企风格，较保守（类：长盛基金）',
        E: '大国企、保守（类：国寿体系）',
      },
      link: '个性标签',
      recover: true,
    },
    {
      id: '9',
      type: 'input',
      stem: '您现在还有别的机会在接触吗？分别是哪些公司？具体岗位？进展到什么阶段了？',
      text: '',
      link: '沟通备注',
    },
    {
      id: '10',
      type: 'radio',
      answer: '',
      stem: '您怎么看这个市场？您怎么看**（该人选所从事方向）业务的发展趋势？',
      options: {
        A: '如数家珍、分析透彻，语气兴奋',
        B: '分析有一定深度、了解较透彻',
        C: '较了解市场，对业务有基本分析',
        D: '仅有通识，缺乏个人判断',
        E: '无任何有效信息',
      },
      link: '沟通备注',
      text: '',
      textLink: '沟通备注',
    },
    {
      id: '11',
      type: 'sort',
      stem: '您现在主要看机会的原因是？新的机会你希望和现在有什么不同？',
      options: [
        '对现在的工作没有不满意，只是非常认可客户公司平台和领导，愿意跟随',
        '想去指定的工作地点',
        '公司出现问题（股东方、管理层等），内部有些动荡',
        '看重更好的个人发展空间，希望有更大的发挥空间',
        '领导发生变化',
        '薪水激励不理想',
        '公司文化风格',
        '业绩压力大',
      ],
      answer: [],
      text: '',
      link: '沟通备注',
      textLink: '沟通备注',
    },
    {
      id: '12',
      type: 'radio',
      answer: '',
      stem: '如果机会非常合适的话，您是一定会走吗，以及您的离职周期',
      options: {
        A: '是',
        B: '否',
        C: '看情况',
      },
      text: '',
      link: '沟通备注',
      textLink: '沟通备注',
      textLabel: '离职周期',
    },
    {
      id: '13',
      type: 'radio',
      answer: '',
      stem: '真的很高兴认识你，希望与您能保持长期联系，有任何我能协助到您的，请随时联系。您的微信号码是手机号码吗？',
      options: {
        A: '是的',
        B: '不是',
      },
      link: '微信',
      text: '',
      textLink: '微信',
      textLabel: '微信',
    },
    {
      id: '14',
      type: 'sort',
      stem: '本次沟通中，候选人都问到了以下哪些问题？',
      options: ['职级', '钱', '汇报直线', '业务思路', '职位要求', '公司资源'],
      answer: [],
      link: '人选诉求',
      text: '',
      textLink: '沟通备注',
    },
  ],
  'IBD-投行': [
    {
      id: '15',
      type: 'multible',
      answer: [],
      stem: '您的主要涉及行业是？',
      options: {
        A: '金融行业',
        B: '信息传媒行业（TMT）',
        C: '医疗健康行业',
        D: '能源化工',
        E: '基础设施与房地产行业',
        F: '装备制造',
        G: '大消费',
      },
      link: '擅长方向',
      text: '',
      textLink: '擅长方向',
      recover: true,
    },
    {
      id: '16',
      type: 'radio',
      answer: '',
      stem: '您会兼负责承揽职能吗？',
      options: {
        A: '专注承揽',
        B: '还是主做承做',
        C: '承揽承做都会负责',
      },
      link: '个性标签',
      recover: true,
    },
    {
      id: '17',
      type: 'input',
      stem: '去年您团队的创收收入大概在多少？（一般股团队在2000-3000W，少数可以达到5000-8000万，极少数可过亿）',
      text: '',
    },
    {
      id: '18',
      type: 'input',
      stem: '你主要负责那些区域？',
      text: '',
      link: '个性标签',
      recover: true,
    },
  ],
  'ABS-资产证券化': [
    {
      id: '19',
      type: 'multible',
      answer: [],
      stem: '您目前偏重承揽承做还是销售？',
      options: {
        A: '承揽',
        B: '承做',
        C: '销售',
      },
      link: '细分职能',
      recover: true,
    },
    {
      id: '20',
      type: 'multible',
      answer: [],
      stem: '您做过哪些细分方向的项目呢？（念答案）',
      options: {
        A: 'REITs',
        B: '消费金融',
        C: '汽车金融',
        D: '信贷ABS',
        E: '供应链金融',
        F: '融资租赁',
      },
      link: '擅长方向',
      recover: true,
      text: '',
      textLink: '擅长方向',
    },
    {
      id: '21',
      type: 'input',
      stem: '去年您团队的创收收入大概在多少？',
      text: '',
      link: '沟通备注',
    },
  ],
  'FI-债券开发执行': [
    {
      id: '22',
      type: 'multible',
      answer: [],
      stem: '您目前主做哪些类型的债券产品呢？',
      options: {
        A: '城投债',
        B: '银行间债券',
        C: '公司债企业债',
        D: 'ABS等类型',
      },
      link: '细分职能',
      recover: true,
      text: '',
      textLink: '沟通备注',
    },
    {
      id: '23',
      type: 'input',
      stem: '您带的团队去年的创收是？今年市场不好，您团队的创收是？',
      text: '',
      link: '沟通备注',
    },
    {
      id: '24',
      type: 'radio',
      answer: '',
      stem: '项目来源主要是个人承揽吗？公司营业部对接的资源大概占到多少，50%？',
      options: {
        A: '公司资源为主',
        B: '全是个人带团队做的',
        C: '模糊回答，一半一半',
      },
      link: '个性标签',
      recover: true,
    },
  ],
  'RI-研究': [
    {
      id: '25',
      type: 'input',
      stem: '有明确具体的诉求条件',
      text: '',
      link: '人选诉求',
    },
    {
      id: '26',
      type: 'multible',
      answer: [],
      stem: '您目前考虑机会的主要原因是什么呢？',
      options: {
        A: '想看更好的平台的机会',
        B: '想去指定的工作地点',
        C: '公司出现问题，内部有些动荡',
        D: '看重更好的个人发展空间',
      },
      link: '沟通备注',
      text: '',
    },
    {
      id: '27',
      type: 'input',
      stem:
        '您期望新平台具有那些优势（对平台的硬件条件期望）？[例如：行业排名、激励机制、待遇、买方：规模、投资风格、考核、转投资的机会、卖方：考核新财富、投入资源]',
      text: '',
      link: '人选诉求',
    },
    {
      id: '28',
      type: 'input',
      stem:
        '您期望新平台给您哪方面的发展条件（对平台软性条件的期望）？[具有管理职能：组长、首席；转换能更接近投资&转投资的机制比较确定的机制；投资风格、内部管理风格等软性的条件]',
      text: '',
      link: '沟通备注',
    },
  ],
  'IS-机构销售': [
    {
      id: '29',
      type: 'multible',
      answer: [],
      stem: '您最擅长哪类产品/服务的销售？',
      options: {
        A: '全产品线销售',
        B: '研报服务',
        C: '企业年金业务（即养老金业务）',
        D: '职业年金业务',
        E: '固收产品',
        F: '资管计划（定向、集合）',
        G: '绝对收益公募产品',
        H: '固定收益公募产品',
        I: '专户',
        J: '打新产品',
        K: '综合国际业务',
        L: '强客户资源（信托产品销售）',
        M: '银行资源：四大行、股份制银行、城商行、农商行',
      },
      link: '擅长方向',
      recover: true,
    },
    {
      id: '30',
      type: 'multible',
      answer: [],
      stem: '您对接哪类机构客户？',
      options: {
        A: '公募基金',
        B: '私募基金',
        C: '保险资管',
        D: '银行',
        E: '证券',
        F: '上市公司',
        G: '境外投资者',
        H: '社保及主权基金',
        I: '年金/养老金',
        J: '信托公司',
        K: '其他',
      },
      link: '细分职能',
      recover: true,
    },
    {
      id: '31',
      type: 'input',
      stem: '你主要负责哪个区域？',
      text: '',
      link: '个性标签',
      recover: true,
    },
  ],
  'DS-渠道销售': [
    {
      id: '32',
      type: 'multible',
      answer: [],
      stem: '您负责哪类渠道？',
      options: {
        A: '总对总',
        B: '银行代销',
        C: '券商代销',
      },
      link: '细分职能',
      recover: true,
    },
    {
      id: '33',
      type: 'multible',
      answer: [],
      stem: '您最强的渠道资源在哪里？',
      options: {
        A: '四大行',
        B: '股份制银行',
        C: '城商行',
        D: '农商行',
      },
      link: '个性标签',
      recover: true,
      text: '',
      // textLink: '个性标签',
    },
    {
      id: '34',
      type: 'input',
      stem: '您对应的业务保有量多大？',
      text: '',
    },
  ],
  'FIS-债券销售': [
    {
      id: '35',
      type: 'multible',
      answer: [],
      stem: '您目前销售的产品类型主要包括哪些？',
      options: {
        A: '债券产品',
        B: '资产证券化产品',
      },
      link: '个性标签',
      recover: true,
      text: '',
      // textLink: '个性标签',
    },
    {
      id: '36',
      type: 'multible',
      answer: [],
      stem: '您目前对接的主要资金方是？',
      options: {
        A: '四大行',
        B: '股份行',
        C: '城商行',
        D: '保险',
        E: '第三方理财',
        F: '券商资管',
      },
      link: '擅长方向',
      recover: true,
      text: '',
      textLink: '擅长方向',
    },
    {
      id: '37',
      type: 'input',
      stem: '您去年的销售业绩是？在公司内的排名是？',
      text: '',
    },
  ],
}

export { getQuestions }
